<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataGlobalPairIndicatorSets',
});

// Базовый тип для сообщений с глобальной парой и набором индикаторов
type GlobalPairIndicatorSetPair = {
  idGlobalPair: number;
  idIndicatorSet: number;
};

// Типы для WebSocket сообщений компонента globalPairIndicatorSets
type GlobalPairIndicatorSetsListMessage = WebSocketMessageWithFields<'global-pair-indicator' | 'pair' | 'calc-info', {
  globalPairIndicatorSets: unknown[];
}>;
type GlobalPairIndicatorNotFoundMessage = WebSocketMessageEmpty<'global-pair-indicator-not-found'>;
type GlobalPairIndicatorSetAddMessage = WebSocketMessageWithFields<'global-pair-indicator-set-add' | 'global-pair-indicator-set-add-success', GlobalPairIndicatorSetPair>;
type GlobalPairIndicatorSetDeleteMessage = WebSocketMessageWithFields<'global-pair-indicator-set-delete' | 'global-pair-indicator-set-delete-success', GlobalPairIndicatorSetPair>;

// Объединенный тип для всех сообщений
type GlobalPairIndicatorSetsWebSocketMessage = 
  | GlobalPairIndicatorSetsListMessage 
  | GlobalPairIndicatorNotFoundMessage 
  | GlobalPairIndicatorSetAddMessage 
  | GlobalPairIndicatorSetDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: GlobalPairIndicatorSetsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'global-pair-indicator':
    case 'pair':
    case 'calc-info':
      store.dispatch('globalPairIndicatorSets/wsSetGlobalPairIndicatorSets', {globalPairIndicatorSets: data.globalPairIndicatorSets});
      break;

    case 'global-pair-indicator-not-found':
      store.dispatch('globalPair/wsSetEmptyGlobalPair');
      break;

    case 'global-pair-indicator-set-add':
    case 'global-pair-indicator-set-add-success':
      store.dispatch('globalPairIndicatorSets/wsGlobalPairIndicatorSetCreate', {
        idGlobalPair: data.idGlobalPair,
        idIndicatorSet: data.idIndicatorSet,
      });
      break;

    case 'global-pair-indicator-set-delete':
    case 'global-pair-indicator-set-delete-success':
      store.dispatch('globalPairIndicatorSets/wsGlobalPairIndicatorSetDelete', {
        idGlobalPair: data.idGlobalPair,
        idIndicatorSet: data.idIndicatorSet,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
